import { CaretDownOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Dropdown, List } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { testCaseDifficultyMap } from './QuestionTab';
import styles from './QuestionTab.scss';

const TestCaseList = ({ testCases }) => {
  const { t } = useTranslation('interview_container');
  const download = (data, name) => {
    const blob = new Blob([data], { type: 'text/plain' });
    const link = document.createElement('a');
    link.download = name;
    link.href = URL.createObjectURL(blob);
    link.click();
  };
  const view = data => {
    const w = window.open();
    w.document.write(data);
  };

  return (
    <List
      itemLayout="horizontal"
      dataSource={testCases}
      renderItem={(item, i) => (
        <List.Item>
          <List.Item.Meta
            title={
              <div className={styles['question-tab__listItem']}>
                <div>
                  <div>
                    {t('test_case_list.name')}:{' '}
                    {item.description || `${t('test_case_list.test_case')} ${i + 1}`}
                  </div>
                  <div>
                    {t('test_case_list.difficulty')}: {testCaseDifficultyMap[item.difficulty]}
                  </div>
                </div>
                <div>
                  <div>
                    {t('test_case_list.visibility')}:{' '}
                    {item.visible ? t('test_case_list.visible') : t('test_case_list.hidden')}
                  </div>
                  <div>
                    {t('test_case_list.points')}: {item.points}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Button
                    onClick={() => {
                      download(item.stdin, 'stdin.txt');
                      download(item.stdout, 'stdout.txt');
                    }}
                  >
                    <DownloadOutlined />
                  </Button>
                  <Dropdown
                    menu={{
                      items: [
                        {
                          key: 'input',
                          label: t('test_case_list.input'),
                          onClick: () => view(item.stdin),
                        },
                        {
                          key: 'output',
                          label: t('test_case_list.output'),
                          onClick: () => view(item.stdout),
                        },
                      ],
                    }}
                  >
                    <Button>
                      <EyeOutlined />
                      <CaretDownOutlined />
                    </Button>
                  </Dropdown>
                </div>
              </div>
            }
          />
        </List.Item>
      )}
    />
  );
};

export default TestCaseList;
